"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeakAuthConfig_1 = __importDefault(require("./PeakAuthConfig"));
const PeakAuthDefaults_1 = __importDefault(require("./PeakAuthDefaults"));
const PeakAuthMetaTags_1 = __importDefault(require("./PeakAuthMetaTags"));
const PeakAuthQueryStrings_1 = __importDefault(require("./PeakAuthQueryStrings"));
const PeakCache_1 = __importDefault(require("../models/PeakCache"));
class PeakAuthResolver {
    constructor(provided = PeakAuthConfig_1.default.provided() || new PeakAuthConfig_1.default(), cache = new PeakCache_1.default()) {
        this.provided = provided;
        this.cache = cache;
    }
    isAuth() { return PeakAuthMetaTags_1.default.auth; }
    environment(value) { return this.isAuth() ? PeakAuthDefaults_1.default.LocalEnvironment : (value || this.provided.environment || PeakAuthDefaults_1.default.ProdEnvironment); }
    baseUri(value) {
        if (value)
            return value;
        let env = this.environment();
        if (env == PeakAuthDefaults_1.default.LocalEnvironment)
            return "";
        if (env == PeakAuthDefaults_1.default.ProdEnvironment)
            return PeakAuthDefaults_1.default.BaseUri;
        return PeakAuthDefaults_1.default.BaseUriEnvironmentFormat.replace("{environment}", env);
    }
    service(value) { return value || PeakAuthQueryStrings_1.default.service || this.provided.service || PeakAuthMetaTags_1.default.service || PeakAuthDefaults_1.default.Service; }
    code(value) { return value || PeakAuthQueryStrings_1.default.code || this.cache.code.value || (this.cache.tokenResponse.value ? this.cache.tokenResponse.value.access_token : undefined) || undefined; }
    refreshCode(value) { return value || PeakAuthQueryStrings_1.default.refreshCode || this.cache.refreshCode.value || (this.cache.tokenResponse.value ? this.cache.tokenResponse.value.refresh_token : undefined) || undefined; }
    autoLogin(value) {
        if (value !== undefined && value !== null)
            return !!value;
        let autoLogin = PeakAuthQueryStrings_1.default.autoLogin;
        if (autoLogin !== undefined)
            return autoLogin;
        return PeakAuthDefaults_1.default.AutoLogin;
    }
    requestCode(value) { return value || PeakAuthQueryStrings_1.default.requestCode || undefined; }
    redirectUri(value) { return value || PeakAuthQueryStrings_1.default.redirectUri || PeakAuthMetaTags_1.default.uri || (this.isAuth() ? PeakAuthDefaults_1.default.RedirectUri : location.href); }
    loginHint(value) { return value || PeakAuthQueryStrings_1.default.loginHint || this.cache.loginHint.value || undefined; }
    adminConsent(value) {
        if (value !== undefined && value !== null)
            return !!value;
        let adminConsent = PeakAuthQueryStrings_1.default.adminConsent;
        if (adminConsent !== undefined)
            return adminConsent;
        return PeakAuthDefaults_1.default.AdminConsent;
    }
    with(value) { return value || PeakAuthQueryStrings_1.default.with || this.cache.provider.value; }
}
exports.default = PeakAuthResolver;
PeakAuthResolver.Instance = new PeakAuthResolver();
